import "./table.scss"
import { Table, Typography, Divider, Box } from '@mui/joy';

const RenderOptions = ({ type, result }) => {
	if (!type) return <>Something went wrong, no information</>
	if (!result) return <>No data found</>
	switch (type) {
		case "json":
			return (
				<Table>
					<tbody>
						{Object.entries(result).map(([key, value], index) => {
							if (!value) {
								return (
									<tr key={index}>
										<td>
											<Typography level="body-lg" fontWeight="lg">{key}</Typography>
										</td>
										<td>
											<Typography level="body-md" color="neutral">No information</Typography>
										</td>
									</tr>
								);
							}

							const isArray = Array.isArray(value);
							const isObject = value !== null && typeof value === 'object' && !Array.isArray(value);

							return (
								<tr key={index}>
									<td>
										<Typography level="body-lg" fontWeight="lg">{key}</Typography>
									</td>
									<td>
										{isArray && value.map((item, idx) => (
											<Box key={idx} sx={{ mb: 2 }}>
												<Typography level="body-md" fontWeight="lg" sx={{ mb: 0.5 }}>
													Item {idx + 1}
												</Typography>
												{Object.entries(item).map(([subKey, subVal]) => (
													<Typography
														key={subKey}
														level="body-sm"
														sx={{ ml: 2, fontSize: '0.95rem' }}
													>
														<strong>{subKey}:</strong> {String(subVal)}
													</Typography>
												))}
												<Divider sx={{ mt: 1 }} />
											</Box>
										))}

										{isObject && (
											<Box sx={{ mb: 2 }}>
												<Typography level="body-md" fontWeight="lg" sx={{ mb: 0.5 }}>
													Item {index + 1}
												</Typography>
												{Object.entries(value).map(([subKey, subVal], subIndex) => {
													if (Array.isArray(subVal)) {
														return (
															<Box key={subIndex} sx={{ ml: 2, mb: 1 }}>
																<Typography
																	level="body-sm"
																	fontWeight="md"
																	sx={{ fontSize: '0.95rem' }}
																>
																	{subKey}:
																</Typography>
																{subVal.map((innerVal, innerIdx) => (
																	<Box key={innerIdx} sx={{ ml: 2 }}>
																		{Object.entries(innerVal).map(([innerKey, innerVal]) => (
																			<Typography
																				key={innerKey}
																				level="body-sm"
																				sx={{ ml: 1, fontSize: '0.95rem' }}
																			>
																				<strong>{innerKey}:</strong> {String(innerVal)}
																			</Typography>
																		))}
																	</Box>
																))}
															</Box>
														);
													}

													return (
														<Typography
															key={subIndex}
															level="body-sm"
															sx={{ ml: 2, fontSize: '0.95rem' }}
														>
															<strong>{subKey}:</strong> {String(subVal)}
														</Typography>
													);
												})}
												<Divider sx={{ mt: 1 }} />
											</Box>
										)}

										{!isArray && !isObject && (
											<Typography level="body-sm" sx={{ fontSize: '0.95rem' }}>
												{String(value)}
											</Typography>
										)}
									</td>
								</tr>
							);
						})}
					</tbody>
				</Table>
			);
		default:
			return <p>{result}</p>
	}
}

const ResultsTable = (props) => {
	const { result } = props
	const parsedAnswer = JSON.parse(result.testResult.answer)
	return (
		<>
			<Typography level='h4'>
				Testing result for: {result.key}
			</Typography>
			<Typography level='h5'>
				output type: {result.type}
			</Typography>
			<RenderOptions result={parsedAnswer} type={result.type} />
			<Typography level="p">Confidence: {result.testResult.confidence}</Typography>
			<Typography level="p">Total run time: {result.testResult?.total_run_time} seconds</Typography>
		</>
	)
}

export default ResultsTable